import *  as axios from 'axios';
import * as partnersUrl from '../../constants/webapi/backoffice/partners';

export function GetUserById(userId, timestamp, nonce, signature) {
	return axios.get(partnersUrl.userByIdPartnerIdUrl("0", userId) + `?timestamp=${timestamp}&nonce=${nonce}&signature=${signature}`)
		.then((response) => {
			return {
				userId: response.data.id,
				phoneNumber: response.data.phoneNumber
			};
		})
		.catch((error) => {
			throw error;
		});
}

export function GenerateOtpCode(userId, timestamp, nonce, signature, phoneNumber) {
	return axios.put(partnersUrl.userByIdPartnerIdUrl("0", userId) + `/generateOtp?timestamp=${timestamp}&nonce=${nonce}&signature=${signature}`, { newPhoneNumber: phoneNumber })
		.then((response) => {
			return {
				userId: response.data.id,
				phoneNumber: response.data.phoneNumber
			};
		})
		.catch((error) => {
			throw error;
		});
}

export function ValidatePhoneNumber(userId, timestamp, nonce, signature, otpCode, phoneNumber) {
	return axios.put(partnersUrl.userByIdPartnerIdUrl("0", userId) + `/updatephone?timestamp=${timestamp}&nonce=${nonce}&signature=${signature}`, { newPhoneNumber: phoneNumber, OTPCode: otpCode })
		.then((response) => {
			return {
				userId: userId,
				phoneNumber: phoneNumber
			};
		})
		.catch((error) => {
			throw error;
		});
}

export function UpdatePassword(userId, timestamp, nonce, signature, password) {
	return axios.put(partnersUrl.userByIdPartnerIdUrl("0", userId) + `/setpassword?timestamp=${timestamp}&nonce=${nonce}&signature=${signature}`, { newPassword: password })
		.then((response) => {
			return {
				userId: userId
			};
		})
		.catch((error) => {
			throw error;
		});
}
